<template>
  <v-card class="text-center" flat tile>
    <span v-html="Articulo[0].NombreSubCat" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Articulo"]),
  },
};
</script>

<style></style>
